import { BaseService, type MessageRequest, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Message, Room } from "@kiddocare-platform/portal-common/communication";
import type { Parent, Pediatrician } from "@kiddocare-platform/portal-common/core";

export class CommunicationChatsService extends BaseService {

  public async GetRoom(ticket: string): Promise<ResponseMessage<{
    room: Room;
    pediatrician: Pediatrician;
    parent: Parent;
  }>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/chats/getRoom/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetRoom", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GetMessages(ticket: string): Promise<ResponseMessage<Array<Message>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/chats/getMessages/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetMessages", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SaveMessage(message: MessageRequest): Promise<ResponseMessage<Message>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/chats/saveMessage`, message);
      return response.data;
    } catch (error: any) {
      this.log.error("SaveMessage", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}